var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"justify-content-center"},[_c('b-col',[_c('b-card',[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(this.message)}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }